import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  flagButtonView: {
    width: 75,
    height: "100%",
    minWidth: 32,
    justifyContent: "center",
    flexDirection: "row",
    alignItems: "center",
  },
  dropDownImage: {
    height: 14,
    width: 12,
  },
  numberText: {
    fontSize: 16,
    color: "#000000",
    flex: 1,
  },
});

export default styles;
